module.exports = __webpack_public_path__ + "img/mobile.0ad34f88.png";